import { useEffect, useState } from "react";
import { certificationService } from "../../services/certification.service";
import { CertificationStatusENUM } from "../../utils/enum";
import { formatDate, formatStringToTitle } from "../../utils/utils";
import DownloadFile from "../certification-process/DownloadFile";
import UpdateCertifications from "./UpdateCertifications";

export default function TransactionDetails({
  certificationData,
  isAdmin = false,
  userData = null,
}) {
  const certificationDatas = certificationData?.formData
    ? certificationData?.formData
    : certificationData;

  const user = JSON.parse(localStorage.getItem("user"));

  const [data, setData] = useState();

  useEffect(() => {
    if (userData) setData(userData);
    else {
      setData(user?.data);
    }
  }, [user?.data.id, userData]);

  const fieldToDisplay = [];

  const orderFieldCommodity = [
    "serviceName",
    "estimatedCommodityVolumePerQuantity",
    "unit",
    "estimatedFirstTransDate",
    "numberOfTranscations",
    "origin",
    "destination",
    "preTransactionCertification",
    "cradleToGate",
    "transactionDescription",
  ];

  const orderFieldProduct = [
    "serviceName",
    "estimatedCommodityVolumePerQuantity",
    "unit",
    "estimatedFirstTransDate",
    "numberOfTranscations",
    "origin",
    "destination",
    "preTransactionCertification",
    "transactionDescription",
  ];

  const orderFieldServiceOther = [
    "transactionDescription",
    "estimatedFirstTransDate",
    "contractTimePeriod",
    "preTransactionCertification",
  ];

  const orderFieldServiceVoyage = [
    "isBallastVoyage",
    "ballastVoyageDescription",
    "vesselType",
    "vesselName",
    "typeOfFuel",
    "fuelConsumed",
    "freightDescription",
    "numberOfTranscations",
    "shippingDate",
    "origin",
    "destination",
    "preTransactionCertification",
    "transactionDescription",
  ];

  const orderFieldServiceFlight = [
    "numberOfTranscations",
    "shippingDate",
    "origin",
    "arrival",
    "airCraftType",
    "preTransactionCertification",
    "transactionDescription",
  ];

  const orderFieldServiceTimeChartering = [
    "vesselType",
    "vesselName",
    "contractTimePeriod",
    "typeOfFuel",
    "fuelConsumed",
    "transactionDescription",
  ];

  const orderFieldServiceTimeFlight = [
    "contractTimePeriod",
    "airCraftType",
    "preTransactionCertification",
    "transactionDescription",
  ];

  const secondStepField = (data) => {
    if (!data.ableToCalculateCF) {
      if (!data.hasCompanyContractedCalculation) {
        return [
          "ableToCalculateCF",
          "hasCompanyContractedCalculation",
          "requireServicesToCalculateCF",
        ];
      }
      return [
        "ableToCalculateCF",
        "hasCompanyContractedCalculation",
        "nameOfServiceProvideCFC",
        "contactAssuranceProvider",
        "emailOfServiceProvider",
      ];
    }
    return ["ableToCalculateCF"];
  };

  const thirdStepField = (data) => {
    if (!data.wantTobeIntroToVeritas) {
      if (data.hasPreferenceForAnotherAssuranceProvider) {
        return [
          "wantTobeIntroToVeritas",
          "hasPreferenceForAnotherAssuranceProvider",
          "anotherNameOfAssuranceProvider",
          "anotherContactOfAssuranceProvider",
          "anotherEmailOfAssuranceProvider",
          "canCOCManagementContatctTheAssuranceProvider",
        ];
      }
      return [
        "wantTobeIntroToVeritas",
        "hasPreferenceForAnotherAssuranceProvider",
      ];
    }
    return ["wantTobeIntroToVeritas"];
  };

  const fourthStep = () => {
    return ["needSupportToAccessVoluntaryCarbonMarkets"];
  };

  const getCommonFields = (data) => {
    const secondFields = secondStepField(data);
    const thirdFields = thirdStepField(data);
    const fourthField = fourthStep();
    return secondFields.concat(thirdFields).concat(fourthField);
  };

  const getNameByCertificationType = (field) => {
    if (field === "serviceName") {
      switch (certificationDatas.certificationType) {
        case 1:
          return "Commodity";
        case 2:
          return "Product";
        case 3:
          return "Service";
        default:
          return;
      }
    }
    if (field === "numberOfTranscations") {
      if (
        certificationDatas.airCraftType &&
        certificationDatas.certificationType === 3
      ) {
        return formatStringToTitle(
          "Estimated number of flights to be certified"
        );
      } else if (
        !certificationDatas.airCraftType &&
        certificationDatas.certificationType === 3
      ) {
        return "Number Of Voyages To Be Certified";
      } else {
        return "Number Of Transaction(s)";
      }
    }
    if (field === "transactionDescription") {
      switch (certificationDatas.certificationType) {
        case 3:
          return certificationDatas.airCraftType
            ? "Additional information"
            : "Service Description";
        default:
          return "Transaction Description";
      }
    }
    if (field === "estimatedFirstTransDate") {
      switch (certificationDatas.certificationType) {
        case 3:
          return certificationDatas.contractTimePeriod &&
            certificationDatas.estimatedFirstTransDate
            ? "Date Of Service"
            : "Date";
        default:
          return "Estimated (First) Transaction(s) Date";
      }
    }
    if (field === "preTransactionCertification") {
      console.log("field pre", field);
      return "Certification";
    }
    if (field === "cradleToGate") {
      return "Boundaries";
    }
    if (field === "estimatedCommodityVolumePerQuantity") {
      switch (certificationDatas.certificationType) {
        case 1:
          return "Estimated Commodity Volume/Quantity";
        case 2:
          return "Estimated Product Volume/Quantity";
        default:
          return;
      }
    }
  };

  const reformatField = (field) => {
    switch (field) {
      case "destination":
        return "Destination (Gate or Grave)";
      case "canCOCManagementContatctTheAssuranceProvider":
        return formatStringToTitle(
          "Can COC contact the Verification body (VVB) ?"
        );
      case "anotherEmailOfAssuranceProvider":
        return formatStringToTitle("email of Verification body (VVB)");
      case "anotherContactOfAssuranceProvider":
        return formatStringToTitle("contact of Verification body (VVB)");
      case "anotherNameOfAssuranceProvider":
        return formatStringToTitle("name of Verification body (VVB)");
      case "ableToCalculateCF":
        return formatStringToTitle("able to calculate carbon footprint");
      case "serviceProvideCFC":
        return formatStringToTitle(
          "service provider of carbon footprint calculation"
        );
      case "requireServicesToCalculateCF":
        return formatStringToTitle(
          "Does the company require services to calculate carbon footprint?"
        );
      case "wantTobeIntroToVeritas":
        return formatStringToTitle("need Introduction to Bureau Veritas?");
      case "nameOfServiceProvideCFC":
        return formatStringToTitle(
          "name of service provider to calculate carbon footprint"
        );
      case "estimatedFirstTransDate":
        return formatStringToTitle("estimated first transaction date");
      case "shippingDate":
        return certificationDatas.airCraftType
          ? "First Flight(s) Date"
          : formatStringToTitle("First Voyage Date");
      case "contactAssuranceProvider":
        return formatStringToTitle("contact service provider");
      case "estimatedCommodityVolumePerQuantity":
        return certificationDatas.certificationType === 1
          ? formatStringToTitle("Estimated Commodity Volume/Quantity")
          : formatStringToTitle("Estimated Product Volume/Quantity");
      case "hasCompanyContractedCalculation":
        return formatStringToTitle(
          "Has contracted a service provider carbon footprint calculation?"
        );
      case "contractTimePeriod":
        return certificationDatas.airCraftType
          ? formatStringToTitle("Certification")
          : formatStringToTitle("Contract time period");
      case "isBallastVoyage":
        return "Ballast Voyage(s)";
      case "vesselName":
        return certificationDatas.contractTimePeriod
          ? formatStringToTitle("Name of vessel")
          : formatStringToTitle("Vessel Name and IMO Number");
      case "fuelConsumed":
        return "Consumed Fuel Quantity (estimated or actual)";
      case "ballastVoyageDescription":
        return "Ballast voyage(s) description";
      case "arrival":
        return formatStringToTitle("Destination");
      case "typeOfFuel":
        return formatStringToTitle("Fuel Type");
      default:
        return formatStringToTitle(field);
    }
  };

  const displayValues = (datas, displayFields) => {
    if (displayFields) {
      for (const field of displayFields) {
        const value = datas[field];

        if (value !== null && value !== "") {
          console.log(`field: ${field}`);
          let valueToDisplay = value;
          if (typeof value === "boolean") {
            valueToDisplay = value ? "Yes" : "No";
          }
          if (field === "estimatedFirstTransDate" || field === "shippingDate") {
            valueToDisplay = new Date(value).toLocaleDateString();
          }
          if (field === "preTransactionCertification") {
            valueToDisplay = value
              ? "Pre-Transaction Certification"
              : "Post-Transaction Certification";
          }
          if (field === "cradleToGate") {
            valueToDisplay = value ? "Cradle To Gate" : "Cradle To Grave";
          }
          if (field === "contractTimePeriod") {
            const fromDate = value && value.split(" to ")[0];
            const toDate = value && value.split(" to ")[1];
            valueToDisplay = `From ${new Date(
              fromDate
            ).toLocaleDateString()} to ${new Date(
              toDate
            ).toLocaleDateString()}`;
          }
          fieldToDisplay.push(
            <div key={field} className="flex justify-between py-2">
              <span className="text-coc-blue">
                {field === "serviceName" ||
                field === "numberOfTranscations" ||
                field === "transactionDescription" ||
                field === "estimatedFirstTransDate" ||
                field === "preTransactionCertification" ||
                field === "cradleToGate"
                  ? getNameByCertificationType(field)
                  : reformatField(field)}
                :
              </span>
              <span className="text-black">{valueToDisplay}</span>
            </div>
          );
        }
      }
    }
  };

  const commonOrderField = getCommonFields(certificationDatas);

  let allFields;
  if (certificationDatas.certificationType === 1) {
    allFields = orderFieldCommodity.concat(commonOrderField);
  } else if (certificationDatas.certificationType === 2) {
    allFields = orderFieldProduct.concat(commonOrderField);
  } else if (certificationDatas.certificationType === 3) {
    if (certificationDatas.ballastVoyageDescription) {
      if (!certificationDatas.isBallastVoyage) {
        const index = orderFieldServiceVoyage.indexOf(
          "ballastVoyageDescription"
        );
        if (index !== -1) {
          orderFieldServiceVoyage.splice(index, 1);
        }
      }
      allFields = orderFieldServiceVoyage.concat(commonOrderField);
    } else if (
      (certificationDatas.estimatedFirstTransDate &&
        certificationDatas.transactionDescription &&
        !certificationDatas.vesselName &&
        !certificationDatas.airCraftType) ||
      (certificationDatas.contractTimePeriod &&
        certificationDatas.transactionDescription &&
        !certificationDatas.vesselName &&
        !certificationDatas.airCraftType)
    ) {
      console.log(`other service`);
      allFields = orderFieldServiceOther.concat(commonOrderField);
    } else if (
      certificationDatas.contractTimePeriod &&
      certificationDatas.vesselName
    ) {
      console.log(`time service`);
      allFields = orderFieldServiceTimeChartering.concat(commonOrderField);
    } else if (
      certificationDatas.airCraftType &&
      !certificationDatas.contractTimePeriod
    ) {
      console.log(`flight service`);
      allFields = orderFieldServiceFlight.concat(commonOrderField);
    } else if (
      certificationDatas.airCraftType &&
      certificationDatas.contractTimePeriod
    ) {
      console.log(`time flight service`);
      allFields = orderFieldServiceTimeFlight.concat(commonOrderField);
    }
  }

  displayValues(certificationDatas, allFields);

  const details =
    isAdmin &&
    certificationDatas.certificationStatus !==
      CertificationStatusENUM.COMPLETED ? (
      <UpdateCertifications certificationsData={certificationDatas} />
    ) : (
      <>
        <div>
          <h2 className="py-9 text-center text-lg text-coc-blue font-weight-bold">
            Application Information
          </h2>
          <div className="grid grid-cols-2 gap-4">
            <div className="px-5">
              <div className="flex justify-between py-2">
                <span className="text-coc-blue capitalize">Email:</span>
                <span className="text-black">{data?.email}</span>
              </div>

              <div className="flex justify-between py-2">
                <span className="text-coc-blue capitalize">Company Name:</span>
                <span className="text-black">{data?.companyName}</span>
              </div>
            </div>
            <div className="px-5">
              <div className="flex justify-between py-2">
                <span className="text-coc-blue capitalize">Last Name:</span>
                <span className="text-black">{data?.lastName}</span>
              </div>
              <div className="flex justify-between py-2">
                <span className="text-coc-blue capitalize">First Name:</span>
                <span className="text-black">{data?.firstName}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4 mt-5">
          <div className="px-5">
            {fieldToDisplay.slice(0, Math.ceil(fieldToDisplay.length / 2))}
          </div>
          <div className="px-5">
            {fieldToDisplay.slice(Math.ceil(fieldToDisplay.length / 2))}
          </div>
        </div>
        {certificationDatas?.creditRetirement && (
          <>
            <h2 className="py-9 text-center text-lg text-coc-blue font-weight-bold">
              Credit Retirement
            </h2>
            <div className="grid 2xl:grid-cols-2 2xl:px-5">
              <div style={{ lineHeight: 1.2 }} className="flex justify-between">
                <div className="flex">
                  <h3 className="text-coc-blue font-medium capitalize">
                    Transaction carbon footprint :{" "}
                  </h3>{" "}
                  <span className="text-black font-medium ml-2">
                    {
                      certificationDatas?.creditRetirement[0]
                        .transactionCarbonFootPrint
                    }
                  </span>
                </div>

                <div className="flex">
                  <h3 className="text-coc-blue font-medium capitalize">
                    Retired Carbon Credits :{" "}
                  </h3>{" "}
                  <span className="text-black font-medium ml-2">
                    {
                      certificationDatas?.creditRetirement[0]
                        .transactionToBeRetired
                    }
                  </span>
                </div>
              </div>
            </div>

            <div className="rounded-lg 2xl:px-5">
              <table className="min-w-full border-collapse block md:table mt-4 border-1 rounded-md px-2 overflow-hidden">
                <thead className="bg-coc-blue h-[70px]">
                  <tr className="border-t border-b md:hidden">
                    <th className="py-6" colSpan="2">
                      Credit Retirement
                    </th>
                  </tr>
                  <tr className="text-gray-600 text-sm md:text-xs lg:text-sm tracking-wider text-center">
                    <th className="text-white font-light">Standard</th>
                    <th className="text-white font-light">Vintage Year</th>
                    <th className=" text-white font-light">Serial Numbers</th>
                    <th className=" text-white font-light">Quantity</th>
                    <th className=" text-white font-light">Project ID</th>
                    <th className=" text-white font-light">
                      Project Description and Location
                    </th>
                    <th className="text-white font-light">Retirement Date</th>
                    <th className="text-white font-light pr-3">
                      Proof of Retirement
                    </th>
                  </tr>
                </thead>
                <tbody className="text-gray-600 text-sm md:text-xs lg:text-sm">
                  {certificationDatas?.creditRetirement.map(
                    (element, index) => {
                      return (
                        <tr key={index} className="border-b text-center">
                          <td className="py-3 text-black  pl-2">
                            {element.standard}
                          </td>
                          <td className="py-3 text-black text-center">
                            {new Date(element.vintageYear).getFullYear()}
                          </td>
                          <td className="py-3 text-black text-center">
                            {element.serialNumbers}
                          </td>
                          <td className="py-3 text-black text-center">
                            {element.quantity}
                          </td>
                          <td className="py-3 text-black text-center">
                            {element.idRetirement}
                          </td>
                          <td className="py-3 text-black text-center">
                            {element.projectDescriptionAndLocation}
                          </td>
                          <td className="py-3 text-black text-center">
                            {new Date(
                              element.retirementDate
                            ).toLocaleDateString()}
                          </td>
                          <td className="py-3 text-black text-center">
                            {element.proofOfRetirement ||
                              (element.attachments.length > 0 &&
                                element.attachments.map((file) => {
                                  return <DownloadFile file={file} />;
                                }))}
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
      </>
    );

  return details;
}
